export const IDENTITY_INFO_SUBMIT_START = 'IDENTITY_INFO_SUBMIT_START';
export const IDENTITY_INFO_SUBMIT_SUCCESS = 'IDENTITY_INFO_SUBMIT_SUCCESS';
export const IDENTITY_INFO_SUBMIT_FAIL = 'IDENTITY_INFO_SUBMIT_FAIL';
export const IDENTITY_INFO_SUBMIT_RESET = 'IDENTITY_INFO_SUBMIT_RESET';
